import { useEffect, useState } from 'react';
import { lastPerf, onPerf, type PerfEntry } from './perf';

/** The debug timing HUD (docs/PERFORMANCE.md): a budget nobody can see is a budget nobody keeps. */
export function PerfHud() {
  const [entries, setEntries] = useState<PerfEntry[]>(lastPerf());
  useEffect(() => onPerf(() => setEntries(lastPerf())), []);
  return (
    <div className="perf-hud" aria-hidden="true">
      {entries.length === 0 ? 'perf: —' : null}
      {entries.map((e) => (
        <div key={e.budget} className={e.over ? 'over' : undefined}>
          {e.budget} {e.ms}ms {e.detail}
        </div>
      ))}
    </div>
  );
}
